import * as Sentry from '@sentry/vue';

/**
 * Initialize Sentry for Vue 3.
 * Note: The Vue app integration is done separately via Sentry.init({ app }) in the plugin.
 * This function initializes Sentry's browser SDK without the Vue-specific integration,
 * returning the Sentry instance for use before the app is created.
 */
const initSentry = ({ project, version, environment, dsn }) => {
  Sentry.init({
    dsn,
    environment,
    release: `${project}@${version}`,
    beforeSend: (event, hint) => {
      // Prevents from logging 'undefined' on development env
      if (environment !== 'production' && (hint.originalException || hint.syntheticException)) {
        // eslint-disable-next-line no-console
        console.error(hint.originalException || hint.syntheticException);
      }
      return event;
    },
  });

  return Sentry;
};

export { initSentry };
